import getBgColor from "../../../../../../../common/components/Popover/getBgColor";
import { StyleSheet } from "../../../../../components/Common/react-native-components";


const styles = StyleSheet.create({
    recommendationsContainer: {
        fontFamily: "Inter"
    },
    prosConsItemMainContainer: {
        // paddingHorizontal: 20
    },
    prosConsButtonContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 10
    },
    prosConsCardContainer: {
        // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;',
        // borderRadius: 18,
        padding: 20,
        marginTop: 20
    },
    prosConsButton: {
        paddingHorizontal: 10,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        paddingVertical: 10,
        borderRadius: 10
    },
    prosButton: {
        backgroundColor: "#8ACA90",
    },
    consButton: {
        backgroundColor: "#E16067"
    },
    prosConsItemContainer: {
        border: "1px solid rgba(156, 156, 156, 0.2)",
        boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: 20,
        padding: 30,
        marginVertical: 15,

    },
    explanationContainer: {
        marginTop: 20
    },
    guestQuotedContainer: {
        marginTop: 20
    },
    explanationTextContainer: {
        marginLeft: 30,
        marginTop: 15
    },
    guestQuotedTextContainer: {
        marginLeft: 30,
        marginTop: 15
    },
    mentionsItem: {
        backgroundColor: "#FAE8E9",
        paddingVertical: 5,
        paddingHorizontal: 10,
        borderRadius: 15
    },
    flexRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 10
    },
    prosHeader: {
        backgroundColor: "#E8F7EB"
    },
    consHeader: {
        backgroundColor: "#F5D6D6"
    },
    prosConsHeader: {
        borderRadius: 20,
        padding: 20,
        marginVertical: 15
    },
    multiSelectContainer: {
        maxWidth: 300
    },
    contentContainer: {
        minHeight: 200,
        justifyContent: "space-between"
    },
    headerText: {
        // color is dynamic
    },
    headerCaption: {
        marginTop: 6
        // color is dynamic
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    mentionsText: {
        // color is dynamic
    },
    italicText: {
        fontStyle: 'italic'
    }
})

export default styles
